/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2025. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: UserInfoVO.ts
 * Created by: chan.ying
 * Create Date: 2025-08-14 15:49
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import ProfileData from "@/utils/cookie/ProfileData";
import MenuAttrs from "@/components/MenuAttrs";

export enum UserStateEnum {
    Unknown = -3,
    Start,
    Rejected,
    Approving,
    Active,
    LoginReady,
    Expired,
    Suspended,
    Online = 100,
}

export default class UserInfoVO {

    public userId: string = "";
    public teamId: string = "";
    public email: string = "";
    public name: string = "";
    public state: number = UserStateEnum.Approving;
    public memberGroups: string = "";
    public createdAt: string = "";
    public lastSignInAt: string = "";
    public lastSignInIp: string = "";
    public avatar: string | null = "";
    public deviceCount: number = 0;
    public cntRegistered: number = 0;
    public cntPending: number = 0;
    public cntOnline: number = 0;

    public groupIds: string[] = []
    // Create request only: the Add User form's "Send Invitation Email" box.
    public sendInvitation: boolean = false;

    public profileSetting: UserProfileInfo = new UserProfileInfo();

    public availableMenus: MenuAttrs[] = [];
    public operatesToScopes: number[] = [];

    public reset(): void {
        this.userId = "";
        this.teamId = "";
        this.email = "";
        this.name = "";
        this.state = UserStateEnum.Unknown;
        this.memberGroups = "";
        this.createdAt = "";
        this.lastSignInAt = "";
        this.lastSignInIp = "";
    }

    public isValid(): boolean {
        return this.userId.length > 0
            && this.teamId.length > 0
            && this.email.length > 0
            && this.name.length > 0
            ;
    }
}

export class UserProfileInfo {

    public pageSize: number = 10;
    public appearance: number = 0;
    public language: number = 0;
    public accent: string = "azure";

    public toJSON(): {pageSize: number; appearance: number; language: number; accent: string} {
        return {
            pageSize: this.pageSize,
            appearance: this.appearance,
            language: this.language,
            accent: this.accent || "azure",
        };
    }

    public static snapshot(): UserProfileInfo {
        let userProfileInfo = new UserProfileInfo();
        userProfileInfo.pageSize = ProfileData.getPageSize();
        userProfileInfo.appearance = ProfileData.getAppearance();
        userProfileInfo.language = ProfileData.getLanguage();
        userProfileInfo.accent = ProfileData.getAccent();
        return userProfileInfo;
    }

    public static setPageSize(pageSize: number): UserProfileInfo {
        let userProfileInfo = UserProfileInfo.snapshot();
        userProfileInfo.pageSize = pageSize;
        return userProfileInfo;
    }

    public static setAppearance(appearance: number): UserProfileInfo {
        let userProfileInfo = UserProfileInfo.snapshot();
        userProfileInfo.appearance = appearance;
        return userProfileInfo;
    }

    public static setLanguage(language: number): UserProfileInfo {
        let userProfileInfo = UserProfileInfo.snapshot();
        userProfileInfo.language = language;
        return userProfileInfo;
    }

    public static setAccent(accent: string): UserProfileInfo {
        let userProfileInfo = UserProfileInfo.snapshot();
        userProfileInfo.accent = accent;
        return userProfileInfo;
    }
}